import { ProviderModel } from 'models/providers';
import { Position } from 'models/wheniwork';

export enum ProvidersConfigTypes {
  SET_AUTH_ERROR = '[Providers] Set Auth Error',
  REMOVE_AUTH_ERROR = '[Providers] Remove Auth Error',
  SHOW_SUMMARY = '[Providers] Show Summary',
  HIDE_SUMMARY = '[Providers] Hide Summary',
  ENABLE_EDIT = '[Providers] Enable Edit',
  DISABLE_EDIT = '[Providers] Disable Edit',
  SET_STEP_ID = '[Providers] Set Step Id',
  SEARCH_PROVIDERS = '[Providers] Search Providers',
  SEARCH_PROVIDERS_SUCCESS = '[Providers] Search Providers Success',
  SEARCH_PROVIDERS_ERROR = '[Providers] Search Providers Error',
  SEARCH_PROVIDERS_CONFIG = '[Providers] Search organization provider configuration',
  SEARCH_PROVIDERS_CONFIG_SUCCESS = '[Providers] Search organization provider configuration Success',
  SEARCH_PROVIDERS_CONFIG_ERROR = '[Providers] Search organization provider configuration Error',
  SAVE_PROVIDERS_CONFIG = '[Providers] Save Providers',
  SAVE_PROVIDERS_CONFIG_SUCCESS = '[Providers] Save Providers Success',
  SAVE_PROVIDERS_CONFIG_ERROR = '[Providers] Save Providers Error',
  DELETE_PROVIDER_CONFIG = '[ProvidersToDelete] Search ProvidersToDelete',
  DELETE_PROVIDER_CONFIG_SUCCESS = '[ProvidersToDelete] Search ProvidersToDelete Success',
  DELETE_PROVIDER_CONFIG_ERROR = '[ProvidersToDelete] Search ProvidersToDelete Error',
  SEARCH_ORGANIZATION_API_KEY = '[GET ORGANIZATION API KEY ID] Search GET ORGANIZATION API KEY ID',
  SEARCH_ORGANIZATION_API_KEY_SUCCESS = '[GET ORGANIZATION API KEY ID] Search GET ORGANIZATION API KEY ID Success',
  SEARCH_ORGANIZATION_API_KEY_ERROR = '[GET ORGANIZATION API KEY ID] Search GET ORGANIZATION API KEY ID Error',
  SEARCH_ORGANIZATION_TOKEN = '[GET ORGANIZATION TOKEN] Search GET ORGANIZATION TOKEN',
  SEARCH_ORGANIZATION_TOKEN_SUCCESS = '[GET ORGANIZATION TOKEN] Search GET ORGANIZATION TOKEN Success',
  SEARCH_ORGANIZATION_TOKEN_ERROR = '[GET ORGANIZATION TOKEN] Search GET ORGANIZATION TOKEN Error',
  SEARCH_AIRTABLE_BASES = '[Providers] Get Airtable Bases',
  SEARCH_AIRTABLE_BASES_SUCCESS = '[Providers] Get Airtable Bases Success',
  SEARCH_AIRTABLE_BASES_ERROR = '[Providers] Get Airtable Bases Error',
  SEARCH_WIW_POSITIONS = '[Providers] Get WhenIWork Positions',
  SEARCH_WIW_POSITIONS_SUCCESS = '[Providers] Get WhenIWork Positions Success',
  SEARCH_WIW_POSITIONS_ERROR = '[Providers] Get WhenIWork Positions Error',
  RESYNC_WIW_USERS = '[Providers] Re-Sync WhenIWork Users',
  RESYNC_WIW_USERS_SUCCESS = '[Providers] Re-Sync WhenIWork Users Success',
  RESYNC_WIW_USERS_ERROR = '[Providers] Re-Sync WhenIWork Users Error',
}

type ISearchProviders = {
  type: typeof ProvidersConfigTypes.SEARCH_PROVIDERS;
};
type ISearchProvidersSuccess = {
  type: typeof ProvidersConfigTypes.SEARCH_PROVIDERS_SUCCESS;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: { data: any[] };
};
type ISearchProvidersError = {
  type: typeof ProvidersConfigTypes.SEARCH_PROVIDERS_ERROR;
  payload: { error: string };
};

type ISearchProvidersConfig = {
  type: typeof ProvidersConfigTypes.SEARCH_PROVIDERS_CONFIG;
};
type ISearchProvidersConfigSuccess = {
  type: typeof ProvidersConfigTypes.SEARCH_PROVIDERS_CONFIG_SUCCESS;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: { data: any[] };
};
type ISearchProvidersConfigError = {
  type: typeof ProvidersConfigTypes.SEARCH_PROVIDERS_CONFIG_ERROR;
  payload: { error: string };
};
type ISaveProvidersConfig = {
  type: typeof ProvidersConfigTypes.SAVE_PROVIDERS_CONFIG;
};
type ISaveProvidersConfigSuccess = {
  type: typeof ProvidersConfigTypes.SAVE_PROVIDERS_CONFIG_SUCCESS;
};
type ISaveProvidersConfigError = {
  type: typeof ProvidersConfigTypes.SAVE_PROVIDERS_CONFIG_ERROR;
  payload: { error: string };
};

type DeleteProviderConfig = {
  type: typeof ProvidersConfigTypes.DELETE_PROVIDER_CONFIG;
};
type DeleteProviderConfigSuccess = {
  type: typeof ProvidersConfigTypes.DELETE_PROVIDER_CONFIG_SUCCESS;
};
type DeleteProviderConfigError = {
  type: typeof ProvidersConfigTypes.DELETE_PROVIDER_CONFIG_ERROR;
  payload: { error: string };
};

type ISearchOrganizationAPIkeyId = {
  type: typeof ProvidersConfigTypes.SEARCH_ORGANIZATION_API_KEY;
};
type ISearchOrganizationAPIkeyIdSuccess = {
  type: typeof ProvidersConfigTypes.SEARCH_ORGANIZATION_API_KEY_SUCCESS;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: { data: any[] };
};
type ISearchOrganizationAPIkeyIdError = {
  type: typeof ProvidersConfigTypes.SEARCH_ORGANIZATION_API_KEY_ERROR;
  payload: { error: string };
};

type ISearchOrganizationToken = {
  type: typeof ProvidersConfigTypes.SEARCH_ORGANIZATION_TOKEN;
};
type ISearchOrganizationTokenSuccess = {
  type: typeof ProvidersConfigTypes.SEARCH_ORGANIZATION_TOKEN_SUCCESS;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: { data: any };
};
type ISearchOrganizationTokenError = {
  type: typeof ProvidersConfigTypes.SEARCH_ORGANIZATION_TOKEN_ERROR;
  payload: { error: string };
};

type ISearchAirtableBases = {
  type: typeof ProvidersConfigTypes.SEARCH_AIRTABLE_BASES;
};
type ISearchAirtableBasesSuccess = {
  type: typeof ProvidersConfigTypes.SEARCH_AIRTABLE_BASES_SUCCESS;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: { data: any[] };
};
type ISearchAirtableBasesError = {
  type: typeof ProvidersConfigTypes.SEARCH_AIRTABLE_BASES_ERROR;
  payload: { error: string };
};

type ISetAuthError = {
  type: typeof ProvidersConfigTypes.SET_AUTH_ERROR;
  payload: { data: string };
};

type IRemoveAuthError = {
  type: typeof ProvidersConfigTypes.REMOVE_AUTH_ERROR;
};

type IShowSummary = {
  type: typeof ProvidersConfigTypes.SHOW_SUMMARY;
};

type IHideSummary = {
  type: typeof ProvidersConfigTypes.HIDE_SUMMARY;
};

type IEnableEdit = {
  type: typeof ProvidersConfigTypes.ENABLE_EDIT;
};

type IDisableEdit = {
  type: typeof ProvidersConfigTypes.DISABLE_EDIT;
};

type ISetStepId = {
  type: typeof ProvidersConfigTypes.SET_STEP_ID,
  payload: { data: number | null }
};

type ISearchWIWPositions = {
  type: typeof ProvidersConfigTypes.SEARCH_WIW_POSITIONS;
};
type ISearchWIWPositionsSuccess = {
  type: typeof ProvidersConfigTypes.SEARCH_WIW_POSITIONS_SUCCESS;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: { data: Position[] };
};
type ISearchWIWPositionsError = {
  type: typeof ProvidersConfigTypes.SEARCH_WIW_POSITIONS_ERROR;
  payload: { error: string };
};

type IResyncWIWUsers = {
  type: typeof ProvidersConfigTypes.RESYNC_WIW_USERS;
};
type IResyncWIWUsersSuccess = {
  type: typeof ProvidersConfigTypes.RESYNC_WIW_USERS_SUCCESS;
};
type IResyncWIWUsersError = {
  type: typeof ProvidersConfigTypes.RESYNC_WIW_USERS_ERROR;
  payload: { error: string };
};


export type ProvidersActionTypes =
  | ISearchProviders
  | ISearchProvidersSuccess
  | ISearchProvidersError
  | ISearchProvidersConfig
  | ISearchProvidersConfigSuccess
  | ISearchProvidersConfigError
  | ISaveProvidersConfig
  | ISaveProvidersConfigSuccess
  | ISaveProvidersConfigError
  | DeleteProviderConfig
  | DeleteProviderConfigSuccess
  | DeleteProviderConfigError
  | ISearchOrganizationAPIkeyId
  | ISearchOrganizationAPIkeyIdSuccess
  | ISearchOrganizationAPIkeyIdError
  | ISearchOrganizationToken
  | ISearchOrganizationTokenSuccess
  | ISearchOrganizationTokenError
  | ISetAuthError
  | IRemoveAuthError
  | IShowSummary
  | IHideSummary
  | ISetStepId
  | IEnableEdit
  | IDisableEdit
  | ISearchAirtableBases
  | ISearchAirtableBasesSuccess
  | ISearchAirtableBasesError
  | ISearchWIWPositions
  | ISearchWIWPositionsSuccess
  | ISearchWIWPositionsError
  | IResyncWIWUsers
  | IResyncWIWUsersSuccess
  | IResyncWIWUsersError;

export const providersActionsCreatorsTypes = {
  enableEdit: (): IEnableEdit => ({
    type: ProvidersConfigTypes.ENABLE_EDIT,
  }),
  disableEdit: (): IDisableEdit => ({
    type: ProvidersConfigTypes.DISABLE_EDIT,
  }),
  showSummary: (): IShowSummary => ({
    type: ProvidersConfigTypes.SHOW_SUMMARY,
  }),
  hideSummary: (): IHideSummary => ({
    type: ProvidersConfigTypes.HIDE_SUMMARY,
  }),
  setStepId: (data:number | null): ISetStepId => ({
    type: ProvidersConfigTypes.SET_STEP_ID,
    payload: { data },
  }),
  setAuthError: (data: string): ISetAuthError => ({
    type: ProvidersConfigTypes.SET_AUTH_ERROR,
    payload: { data },
  }),
  removeAuthError: (): IRemoveAuthError => ({
    type: ProvidersConfigTypes.REMOVE_AUTH_ERROR,
  }),
  searchProviders: (): ISearchProviders => ({
    type: ProvidersConfigTypes.SEARCH_PROVIDERS,
  }),
  searchProvidersSuccess: (data: ProviderModel[]): ISearchProvidersSuccess => ({
    type: ProvidersConfigTypes.SEARCH_PROVIDERS_SUCCESS,
    payload: { data },
  }),
  searchProvidersError: (error: string): ISearchProvidersError => ({
    type: ProvidersConfigTypes.SEARCH_PROVIDERS_ERROR,
    payload: { error },
  }),
  searchProvidersConfig: (): ISearchProvidersConfig => ({
    type: ProvidersConfigTypes.SEARCH_PROVIDERS_CONFIG,
  }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  searchProvidersConfigSuccess: (data: any[]): ISearchProvidersConfigSuccess => ({
    type: ProvidersConfigTypes.SEARCH_PROVIDERS_CONFIG_SUCCESS,
    payload: { data },
  }),
  searchProvidersConfigError: (error: string): ISearchProvidersConfigError => ({
    type: ProvidersConfigTypes.SEARCH_PROVIDERS_CONFIG_ERROR,
    payload: { error },
  }),
  saveProvidersConfig: (): ISaveProvidersConfig => ({
    type: ProvidersConfigTypes.SAVE_PROVIDERS_CONFIG,
  }),
  saveProvidersConfigSuccess: (): ISaveProvidersConfigSuccess => ({
    type: ProvidersConfigTypes.SAVE_PROVIDERS_CONFIG_SUCCESS,
  }),
  saveProvidersConfigError: (error: string): ISaveProvidersConfigError => ({
    type: ProvidersConfigTypes.SAVE_PROVIDERS_CONFIG_ERROR,
    payload: { error },
  }),
  searchOrganizationApikeysId: (): ISearchOrganizationAPIkeyId => ({
    type: ProvidersConfigTypes.SEARCH_ORGANIZATION_API_KEY,
  }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  searchOrganizationAPIkeysIdSuccess: (data: any[]): ISearchOrganizationAPIkeyIdSuccess => ({
    type: ProvidersConfigTypes.SEARCH_ORGANIZATION_API_KEY_SUCCESS,
    payload: { data },
  }),
  searchOrganizationAPIkeysIdError: (error: string): ISearchOrganizationAPIkeyIdError => ({
    type: ProvidersConfigTypes.SEARCH_ORGANIZATION_API_KEY_ERROR,
    payload: { error },
  }),
  searchOrganizationToken: (): ISearchOrganizationToken => ({
    type: ProvidersConfigTypes.SEARCH_ORGANIZATION_TOKEN,
  }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  searchOrganizationTokenSuccess: (data: any[]): ISearchOrganizationTokenSuccess => ({
    type: ProvidersConfigTypes.SEARCH_ORGANIZATION_TOKEN_SUCCESS,
    payload: { data },
  }),
  searchOrganizationTokenError: (error: string): ISearchOrganizationTokenError => ({
    type: ProvidersConfigTypes.SEARCH_ORGANIZATION_TOKEN_ERROR,
    payload: { error },
  }),
  deleteProvidersInfo: (): DeleteProviderConfig => ({
    type: ProvidersConfigTypes.DELETE_PROVIDER_CONFIG,
  }),
  deleteProvidersInfoSuccess: (): DeleteProviderConfigSuccess => ({
    type: ProvidersConfigTypes.DELETE_PROVIDER_CONFIG_SUCCESS,
  }),
  deleteProvidersInfoError: (error: string): DeleteProviderConfigError => ({
    type: ProvidersConfigTypes.DELETE_PROVIDER_CONFIG_ERROR,
    payload: { error },
  }),
  searchAirtableBases: (): ISearchAirtableBases => ({
    type: ProvidersConfigTypes.SEARCH_AIRTABLE_BASES,
  }),
  searchAirtableBasesSuccess: (data: object[]): ISearchAirtableBasesSuccess => ({
    type: ProvidersConfigTypes.SEARCH_AIRTABLE_BASES_SUCCESS,
    payload: { data },
  }),
  searchAirtableBasesError: (error: string): ISearchAirtableBasesError => ({
    type: ProvidersConfigTypes.SEARCH_AIRTABLE_BASES_ERROR,
    payload: { error },
  }),
  searchWIWPositions: (): ISearchWIWPositions => ({
    type: ProvidersConfigTypes.SEARCH_WIW_POSITIONS,
  }),
  searchWIWPositionsSuccess: (data: Position[]): ISearchWIWPositionsSuccess => ({
    type: ProvidersConfigTypes.SEARCH_WIW_POSITIONS_SUCCESS,
    payload: { data },
  }),
  searchWIWPositionsError: (error: string): ISearchWIWPositionsError => ({
    type: ProvidersConfigTypes.SEARCH_WIW_POSITIONS_ERROR,
    payload: { error },
  }),
  resyncWIWUsers: (): IResyncWIWUsers => ({
    type: ProvidersConfigTypes.RESYNC_WIW_USERS,
  }),
  resyncWIWUsersSuccess: (): IResyncWIWUsersSuccess => ({
    type: ProvidersConfigTypes.RESYNC_WIW_USERS_SUCCESS,
  }),
  resyncWIWUsersError: (error: string): IResyncWIWUsersError => ({
    type: ProvidersConfigTypes.RESYNC_WIW_USERS_ERROR,
    payload: { error },
  }),
};
